function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import Select from "react-select";
import "./paymentMethods.scss";
import defaultPaymentInformation from "../../../../paymentInformation/defaultPaymentInformation";
import { InputRut, Input, fullName } from "../../../../../helperComponents";
import { TipoDePagoTypes } from "../../../../../utils/data";

var WireTransferInfo = function WireTransferInfo(props) {
  var poliza = props.poliza,
      token = props.token,
      banksOption = props.banksOption,
      _onChange = props.onChange;

  var _React$useState = React.useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isCheckContratante = _React$useState2[0],
      setIsCheckContratante = _React$useState2[1];

  var accountTypeOptions = [{
    value: "checkingAccount",
    label: "Cuenta Corriente"
  }, {
    value: "vistaAccount",
    label: "Cuenta Vista"
  }];
  var selectedBank = poliza.payment_information.bank_id ? banksOption.find(function (option) {
    return parseInt(option.value) === poliza.payment_information.bank_id;
  }) : null;
  var selectedAccountType = poliza.payment_information.account_type ? accountTypeOptions.find(function (option) {
    return option.value === poliza.payment_information.account_type;
  }) : null;

  var onCopyToContratante = function onCopyToContratante() {
    _onChange && _onChange(_objectSpread(_objectSpread({}, poliza.payment_information), {}, {
      titular_rut: poliza.contratante.rut,
      titular_name: fullName(poliza.contratante),
      user_id: poliza.contratante.id
    }));
  };

  var onChangeCheckContratante = function onChangeCheckContratante() {
    var newIsCheckContratante = !isCheckContratante;

    if (newIsCheckContratante) {
      _onChange(_objectSpread(_objectSpread({}, poliza.payment_information), defaultPaymentInformation));
    } else {
      onCopyToContratante();
    }

    setIsCheckContratante(newIsCheckContratante);
  };

  React.useEffect(function () {
    var user_id = poliza.payment_information.user_id;
    var contratante_id = poliza.contratante.id; // Si los datos del contratante están cargados automáticamente, marcar como copiado

    if (user_id === contratante_id && poliza.payment_information.titular_name && poliza.payment_information.titular_rut) {
      setIsCheckContratante(true);
    } else if (user_id && user_id !== contratante_id && isCheckContratante) {
      setIsCheckContratante(false);
    }
  }, [poliza.payment_information.user_id, poliza.payment_information.titular_name, poliza.payment_information.titular_rut, poliza.contratante.id]);
  return /*#__PURE__*/React.createElement("div", {
    className: "container-fluid cntWireTransferInfo"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "title"
  }, "M\xE9todo de pago: Transferencia Bancaria")), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12 checkbox"
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: isCheckContratante,
    onChange: onChangeCheckContratante
  }), "Copiar datos del contratante"))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement(InputRut, {
    value: poliza.payment_information.titular_rut,
    token: token,
    title: "Rut Titular",
    disabled: isCheckContratante,
    onUserIsExist: function onUserIsExist(user) {
      if (_onChange) {
        // Cargar datos bancarios del usuario seleccionado
        var updatedPaymentInfo = _objectSpread(_objectSpread({}, poliza.payment_information), {}, {
          titular_rut: user.rut,
          titular_name: fullName(user),
          user_id: user.id
        }); // Si es cuenta corriente, establecer valores por defecto


        if (poliza.tipo_de_pago === TipoDePagoTypes.PAC) {
          updatedPaymentInfo.payment_type = 'bank_transfer';
          updatedPaymentInfo.account_type = 'checkingAccount';
        }

        _onChange(updatedPaymentInfo);
      }
    },
    onInputChange: function onInputChange(inputValue) {
      if (_onChange) {
        // Buscar automáticamente el usuario si el RUT es válido
        if (inputValue && inputValue.length >= 8) {
          // RUT mínimo válido
          // Hacer búsqueda automática del usuario
          fetch("/api/v1/users?inputSearch=".concat(inputValue), {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "X-CSRF-Token": token
            }
          }).then(function (response) {
            return response.json();
          }).then(function (users) {
            // Buscar usuario que coincida exactamente con el RUT
            var matchingUser = users.find(function (user) {
              return user.rut && user.rut.replace(/[^0-9kK]/g, '') === inputValue.replace(/[^0-9kK]/g, '');
            });

            if (matchingUser) {
              // Autocompletar datos del usuario encontrado
              _onChange(_objectSpread(_objectSpread({}, poliza.payment_information), {}, {
                titular_rut: matchingUser.rut,
                titular_name: fullName(matchingUser),
                user_id: matchingUser.id
              }));
            } else {
              // Solo actualizar RUT si no se encuentra usuario
              _onChange(_objectSpread(_objectSpread({}, poliza.payment_information), {}, {
                titular_rut: inputValue,
                user_id: null
              }));
            }
          })["catch"](function (error) {
            console.error('Error buscando usuario:', error); // En caso de error, solo actualizar RUT

            _onChange(_objectSpread(_objectSpread({}, poliza.payment_information), {}, {
              titular_rut: inputValue,
              user_id: null
            }));
          });
        } else {
          // Si el RUT es muy corto, solo actualizar RUT
          _onChange(_objectSpread(_objectSpread({}, poliza.payment_information), {}, {
            titular_rut: inputValue,
            user_id: null
          }));
        }
      }
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Nombre Titular"), /*#__PURE__*/React.createElement(Input, {
    value: poliza.payment_information.titular_name,
    classNameInput: "form-control",
    disabled: isCheckContratante,
    onChange: function onChange(event) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, poliza.payment_information), {}, {
        titular_name: event.target.value
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Banco"), /*#__PURE__*/React.createElement(Select, {
    value: selectedBank,
    options: banksOption,
    placeholder: "Selecciona...",
    onChange: function onChange(item) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, poliza.payment_information), {}, {
        bank_id: parseInt(item.value)
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Tipo de cuenta"), /*#__PURE__*/React.createElement(Select, {
    value: selectedAccountType,
    options: accountTypeOptions,
    placeholder: "Selecciona...",
    onChange: function onChange(item) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, poliza.payment_information), {}, {
        account_type: item.value
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "N\xFAmero de cuenta"), /*#__PURE__*/React.createElement(Input, {
    value: poliza.payment_information.account_number,
    classNameInput: "form-control",
    onChange: function onChange(event) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, poliza.payment_information), {}, {
        account_number: event.target.value
      }));
    }
  }))));
};

export default WireTransferInfo;